"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const platform_1 = require("../common/platform");
const screen_1 = require("../common/screen");
const DESKTOP_SIZE = 16;
const getBaseSpacingsSize = () => {
    switch (true) {
        case (0, platform_1.isDesktop)():
            return DESKTOP_SIZE;
        default:
            return (0, screen_1.getBaseSizeFromScreenWidth)();
    }
};
const getSpacings = () => {
    const base = getBaseSpacingsSize();
    return {
        abs16: base,
        abs2: base / 8,
        abs24: base * 1.5,
        abs32: base * 2,
        abs4: base / 4,
        abs40: base * 2.5,
        abs48: base * 3,
        abs64: base * 4,
        abs8: base / 2,
    };
};
exports.default = getSpacings;
